import React from "react"
import Table from "components/Table"
import { config } from "./config"
import withUrls from "hoc/withUrls"
import withData from "hoc/withData"
import { taskRequest } from "data/tasks/api"
import * as R from "ramda"

const AssessmentsTable = ({ data, refetchData, urls }) => (
  <Table
    config={config(urls, refetchData)}
    data={data}
    sorting={{
      index: 4,
      desc: true,
    }}
  />
)

export default R.compose(
  withUrls,
  withData(() => taskRequest.assessments()),
)(AssessmentsTable)
